<template>
  <div>
    <!-- 面包屑导航 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>钱包管理</el-breadcrumb-item>
    </el-breadcrumb> -->
    <el-card class="box-card" v-loading="loadings">
      <h3>统计搜索 <span> ( 生成时间：{{ new Date(sumData.generateAt*1000).toLocaleString() }} )</span></h3>
      <p v-if="sumData.userName">用户名 ： {{ sumData.userName }}</p>
      <div>
        <p v-if="sumData.start">开始时间 ：{{ sumData.start }}</p>
        <p v-if="sumData.end">结束时间 ：{{ sumData.end }}</p>
      </div>
      <p>需要兑换的总M ：{{ sumData.publishVolTotalM }}</p>
      <p>已兑换的总M ：{{ sumData.dealVolM }}</p>
      <p>挂单总手续费M ：{{ sumData.feesM }}</p>
      <p>已兑换U ：{{ sumData.exchangeVolU }}</p>
    </el-card>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="用户名">
        <el-input size="small" v-model="formInline.userName" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="时间">
        <el-date-picker
        size="small"
        v-model="timeVal"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期">
      </el-date-picker>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="success" icon="el-icon-search" @click="getDepositSum">统计搜索</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="orderId" label="c2c订单Id" min-width="60">
      </el-table-column>
      <el-table-column align="center" prop="userName" label="用户名" min-width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="dealVol" label="已成交(M)" min-width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="remainVol" label="剩余数量(M)" min-width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="exchangeVol" label="兑换数量(U)" min-width="100">
      </el-table-column>
      <el-table-column align="center" sortable prop="publishVol" label="发布数量(M)" min-width="100">
      </el-table-column>
      <el-table-column align="center" label="状态" min-width="100">
          <template slot-scope="scope">
            <div v-if="scope.row.orderStatus == 'waiting'">等待中</div>
            <div v-if="scope.row.orderStatus == 'ongoing'">进行中</div>
            <div v-if="scope.row.orderStatus == 'canceling'">撤单中</div>
            <div v-if="scope.row.orderStatus == 'cancel'">已撤单</div>
            <div v-if="scope.row.orderStatus == 'complete'">完成</div>
            <div v-if="scope.row.orderStatus == 'failed'">失败</div>
          </template>
        </el-table-column>
      <!--  订单状态 -->
       
      <el-table-column align="center" label="txId" min-width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.txId != ''"><el-link icon="el-icon-link" type="primary" :underline="false" :title="scope.row.txId" :href="scope.row.url" target="_blank">{{ scope.row.txId.slice(0,6)+'……'+scope.row.txId.substr(scope.row.txId.length-6,6) }}</el-link></div>
          <div v-else>无</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="setupTIme" label="创建时间" min-width="200">
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { ExchangeList , ExchangeSum } from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      loading: false, //是显示加载
      loadings: false,
      // rules表单验证
      rules: {
        deptName: [
          { required: true, message: '请输入部门名称', trigger: 'blur' }
        ],
        deptNo: [{ required: true, message: '请输入部门代码', trigger: 'blur' }]
      },
      formInline: {
        from: 1,
        limit: 10,
        startTime: "",
        endTime: "",
        userName: ""
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      typeToken: [
        { key: '默认', value: '' },
        { key: 'USDT', value: 'USDT' },
        { key: 'MCoin', value: 'MCoin' },
      ],
      timeVal:"",
      sumData:{
        end: null,
        generateAt: null,
        start: null,
        userName: null,
        dealVolM: null,
        exchangeVolU: null,
        publishVolTotalM: null,
        feesM: null,
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
    this.getDepositSum()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取转入列表
    getdata(parameter) {
      this.loading = true
      ExchangeList(parameter)
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data.list
            // 分页赋值
            // this.pageparm.currentPage = this.formInline.from
            // this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    getDepositSum() {
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      let obj = {
        "startTime": this.formInline.startTime,
        "endTime": this.formInline.endTime,
        "userName":this.formInline.userName
      }
      // console.log(this.formInline)
      this.loadings = true
      ExchangeSum(obj).then(res => {
          this.loadings = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.sumData = res.data
          }
        })
        .catch(err => {
          this.loadings = false
          this.$message.error('列表加载失败，请稍后再试！')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.pageparm.pageSize = parm.pageSize
      this.formInline.from = (parm.currentPage-1)*(this.pageparm.pageSize) + 1
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.pageparm.currentPage = 1
      this.formInline.from = 1
      console.log(this.timeVal)
      if(this.timeVal instanceof Array){
        this.formInline.startTime = this.timeVal[0]+' 00:00:00'
        this.formInline.endTime = this.timeVal[1]+' 23:59:59'
      }else{
        this.formInline.startTime = ''
        this.formInline.endTime = ''
      }
      this.getdata(this.formInline)
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box-card{
  width: 550px;
  margin-top: 20px;
  font-size: 14px;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/wallet/Exchange.vue